import React from "react";
import "./styles/LandingView.css";
import Roles from "../constants/userRoleEnum";

class LandingView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: "false",
    };
  }

  componentDidMount() {}

  render() {
    var handleRoleSelection = this.props.handleRoleSelection;
    return (
      <div className="flex-container">
        <div className="flex-item">
          Welcome to VibeCheck! Please select your role below.
        </div>
        <div className="flex-item">
          <button
            className="button"
            onClick={() => {
              handleRoleSelection(Roles.SPEAKER);
            }}
          >
            Speaker
          </button>
          <button
            className="button"
            onClick={() => {
              handleRoleSelection(Roles.ATTENDEE);
            }}
          >
            Attendee
          </button>
        </div>
      </div>
    );
  }
}

export default LandingView;
